/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trimbleLinkControllerLink } from "./trimbleLinkControllerLink";

export function authService() {
  return { trimbleLinkControllerLink }
}